<template>
  <div class="keyboard-clean-page page-container">
    <section class="page-header">
      <h1>键盘清洁</h1>
      <p>全屏锁定页面，方便安全擦拭键盘</p>
    </section>
    <section class="clean-card">
      <div class="clean-icon"><i class="el-icon-keyboard" /></div>
      <div><h2>清洁模式</h2><p>启动后进入深色全屏遮罩，站内的快捷键与点击操作不会被触发，可安心擦拭键盘。</p></div>
      <el-button type="primary" icon="el-icon-full-screen" @click="startCleaning">开始清洁</el-button>
    </section>
    <div v-if="cleaning" class="cleaning-overlay">
      <div class="cleaning-content"><i class="el-icon-keyboard" /><h2>键盘清洁中</h2><p>页面按键操作已拦截。</p><el-button plain @click="stopCleaning">结束清洁</el-button><small>也可以按 Esc 退出</small></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyboardCleanPage',
  data() { return { cleaning: false } },
  mounted() { window.addEventListener('keydown', this.handleKeydown, true) },
  beforeDestroy() { window.removeEventListener('keydown', this.handleKeydown, true); this.exitFullscreen() },
  methods: {
    startCleaning() { this.cleaning = true; this.$nextTick(() => document.documentElement.requestFullscreen && document.documentElement.requestFullscreen().catch(() => {})) },
    stopCleaning() { this.cleaning = false; this.exitFullscreen() },
    exitFullscreen() { if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(() => {}) },
    handleKeydown(event) { if (!this.cleaning) return; event.preventDefault(); event.stopPropagation(); if (event.key === 'Escape') this.stopCleaning() }
  }
}
</script>

<style scoped>
.keyboard-clean-page { min-height: calc(100vh - 180px); padding-top: 32px; padding-bottom: 80px; }
.clean-card { display: flex; align-items: center; gap: 22px; max-width: 900px; margin: 32px auto 0; padding: 34px; border: 1px solid var(--line); border-radius: var(--r-lg); background: var(--surface); box-shadow: var(--shadow-1); }
.clean-icon { display: grid; place-items: center; width: 62px; height: 62px; border-radius: var(--r-lg); background: var(--brand-soft); color: var(--brand); font-size: 30px; }
.clean-card div:nth-child(2) { flex: 1; }
.clean-card h2 { margin: 0 0 8px; color: var(--ink); font-size: 22px; font-weight: 600; }
.clean-card p { margin: 0; color: var(--ink-2); line-height: 1.7; }
.cleaning-overlay { position: fixed; inset: 0; z-index: 3000; display: grid; place-items: center; background: #050505; }
.cleaning-content { text-align: center; color: #fff; }
.cleaning-content > i { font-size: 78px; color: var(--brand); }
.cleaning-content h2 { margin: 24px 0 10px; font-size: 32px; }
.cleaning-content p { color: #b8c5ce; }
.cleaning-content small { display: block; margin-top: 18px; color: #71808a; }
@media(max-width:650px){ .clean-card { align-items: flex-start; flex-wrap: wrap; padding: 24px; } .clean-card .el-button { width: 100%; } }
</style>
